import type { FieldValues } from 'react-hook-form';
import type { FormFieldBinding } from '../../../components/formFields';

/**
 * The fields a Planum and a Profil BOTH carry — what the shared sections in
 * this folder are written against.
 *
 * Each form's own `FormValues` adds to this: the Planum its Planumnummer, its
 * length/diameter and the Abstich; the Profil its Profilnummer. The section
 * that shows them takes them as a rendered node (`DimensionsSection.measures`).
 */
export interface DescriptionFormValues extends FieldValues {
    findingId: string;
    parcelId: string;
    area: string;
    trench: string;
    sondage: string;
    editor: string;
    width: string;
    depth: string;
    heightTop: string;
    heightBottom: string;
    form: string;
    orientation: string;
    excavationMethod: string;
    soilType: string;
    consistency: string;
    boundaryClarity: string;
    boundaryBasis: string;
    contour: string;
    humusContent: string;
    overliesOrCuts: string;
    underliesOrIsCut: string;
    contemporaryWith: string;
    fills: string;
    filledBy: string;
    description: string;
    interpretation: string;
    recordedAt: string;
    phaseNumber: string;
}

/**
 * A form's binding seen as the description fields the shared sections touch.
 *
 * The cast is the one TypeScript cannot make for us: a `FormFieldBinding` holds
 * react-hook-form's own function types over the WHOLE value shape, so a Planum
 * binding is not assignable to a description binding even though every field
 * the sections name exists on it. The `extends` constraint is what checks that;
 * the cast only gets the variance out of the way.
 */
export function asDescriptionBinding<Values extends DescriptionFormValues>(
    binding: FormFieldBinding<Values>
): FormFieldBinding<DescriptionFormValues> {
    return binding as unknown as FormFieldBinding<DescriptionFormValues>;
}
